import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-任务派遣-",
  "use": "icon-任务派遣--usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-任务派遣-\">\n<style type=\"text/css\">\n\t#icon-任务派遣- .st0{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t#icon-任务派遣- .st1{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n</style>\n<path d=\"M12.4,8.6v2.8c0,0.6-0.5,1-1.1,1H5c-0.6,0-1.1-0.4-1.1-1V8.7v0V8.6L5,4.2c0-0.1,0.2-0.3,0.4-0.3h5.5c0.2,0,0.3,0.1,0.4,0.3\n\tC11.3,4.2,12.4,8.6,12.4,8.6z M11.6,8.4l-1-3.7h-5l-1,3.7H6c0.1,0,0.2,0,0.2,0.1l1,0.9H9l1-0.9c0.1-0.1,0.1-0.1,0.2-0.1\n\tC10.3,8.4,11.6,8.4,11.6,8.4z M11.7,9.1h-1.3l-1,0.9c-0.1,0.1-0.1,0.1-0.2,0.1H7.1c-0.1,0-0.2,0-0.2-0.1l-1-0.9H4.6v2.4\n\tc0,0.2,0.1,0.3,0.4,0.3h6.4c0.2,0,0.4-0.1,0.4-0.3V9.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/任务派遣-.svg
// module id = 3FJ8
// module chunks = 166